import PropTypes from "prop-types";
import { isAllowedByRoles } from "../../utils/auth/permissions";

function ProtectedRoute({ children, failComponent, userData, permission }) {
  const canSeePath = isAllowedByRoles(userData, permission);

  if (canSeePath === true) {
    return children;
  }

  return failComponent;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  failComponent: PropTypes.elementType.isRequired,
  userData: PropTypes.shape({}).isRequired,
  permission: PropTypes.string,
  exact: PropTypes.bool,
};

ProtectedRoute.defaultProps = {
  permission: "",
  exact: false,
};

export default ProtectedRoute;
